import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthShell from "../components/AuthShell";
import PasswordInput from "../components/PasswordInput";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function AgencyLogin() {
  const { loginWithCredentials, apiError } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await loginWithCredentials(email.trim(), password);
      if (user.role === "client") {
        toast.error("Questo account è un account cliente. Usa l'area Cliente.");
        return;
      }
      toast.success(`Benvenuto ${user.full_name || user.email}`);
      navigate("/dashboard");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      side="agency"
      title="Accedi — Agenzia"
      subtitle="Inserisci le credenziali del tuo account agenzia o amministratore."
      altLinkLabel="Richiedi accesso →"
      altLinkTo="/agenzia/registrati"
      altLinkDataTestId="agency-login-to-register"
    >
      <form onSubmit={onSubmit} data-testid="agency-login-form" className="space-y-5">
        <div>
          <Label htmlFor="email" className="text-xs font-bold uppercase tracking-[0.18em]">
            Email
          </Label>
          <Input
            id="email"
            data-testid="agency-login-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-2 h-12 rounded-xl border-[var(--mp-ink)]"
            placeholder="nome@agenzia.it"
          />
        </div>
        <div>
          <div className="flex items-center justify-between">
            <Label htmlFor="password" className="text-xs font-bold uppercase tracking-[0.18em]">
              Password
            </Label>
            <Link
              to="/password-dimenticata"
              data-testid="agency-login-forgot"
              className="text-xs font-semibold text-[var(--mp-muted)] hover:text-[var(--mp-ink)] underline underline-offset-2"
            >
              Password dimenticata?
            </Link>
          </div>
          <PasswordInput
            id="password"
            dataTestId="agency-login-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-2 h-12 rounded-xl border-[var(--mp-ink)]"
            placeholder="••••••••"
          />
        </div>
        <Button
          type="submit"
          disabled={loading}
          data-testid="agency-login-submit"
          className="w-full h-12 rounded-full bg-[var(--mp-ink)] hover:bg-black text-white"
        >
          {loading ? "Accesso in corso…" : "Accedi"}
        </Button>
      </form>
    </AuthShell>
  );
}
